var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19552",
    "data-name": "Group 19552",
    transform: "translate(-770.996 -16.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Number_style_",
    "data-name": "Number (style)",
    width: 28,
    height: 28,
    rx: 6,
    transform: "translate(771.496 17)",
    fill: "#fff",
    stroke: "#eee",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_Stroke_",
    "data-name": "Oval (Stroke)",
    d: "M9.712,14A9.837,9.837,0,0,1,3.5,11.81,13.684,13.684,0,0,1,.314,8.133a2.2,2.2,0,0,1,0-2.267A13.689,13.689,0,0,1,3.5,2.19a9.9,9.9,0,0,1,12.418,0,13.7,13.7,0,0,1,3.189,3.676,2.2,2.2,0,0,1,0,2.267,13.7,13.7,0,0,1-3.189,3.677A9.838,9.838,0,0,1,9.712,14Zm0-12c-4.13,0-6.586,3.067-7.682,4.9A.207.207,0,0,0,2,7a.2.2,0,0,0,.032.1C3.126,8.933,5.581,12,9.712,12S16.3,8.933,17.4,7.1a.2.2,0,0,0,.031-.1.2.2,0,0,0-.031-.105C16.3,5.067,13.843,2,9.712,2Z",
    transform: "translate(775.496 24)",
    fill: "#6f767e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_138_Stroke_",
    "data-name": "Ellipse 138 (Stroke)",
    d: "M3,6A3,3,0,1,1,6,3,3,3,0,0,1,3,6ZM3,2A1,1,0,1,0,4,3,1,1,0,0,0,3,2Z",
    transform: "translate(782.209 28)",
    fill: "#6f767e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3139fbbfe6e9f6ddbf647655f3b5c647.svg";
export { ForwardRef as ReactComponent };